import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_LEVEL_DEDUCTION_DATA:
      return action.payload;

    default:
      return state;
  }
}
